import { IotTypography } from "@core/presentation/components/general/typography/iot-typography.component";
import { IotCol } from "@core/presentation/components/layout/col/iot-col.component";
import { IotRow } from "@core/presentation/components/layout/row/iot-row.component";
import { useEnvironment } from "@core/presentation/hook/use-environment/use-environment.hook.ts";
import { Result } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router";

export const ErrorInRoute: FC = () => {
    const error = useRouteError();
    const { t } = useTranslation("error");
    const env = useEnvironment();

    let errorDetail = undefined;
    if (isRouteErrorResponse(error)) {
        errorDetail = error.statusText;
    } else if (error instanceof Error) {
        errorDetail = error.message;
    }

    const isProd = env.isProduction;

    console.error(error);

    return (
        <IotRow
            justify={"center"}
            align={"middle"}
            className={"tw:h-[100vh]"}
        >
            <IotCol span={24}>
                <Result
                    title={t("core.errorInRoute.errorTitle")}
                    subTitle={
                        isProd ? undefined : (
                            <IotRow justify={"center"}>
                                <IotCol span={6}>
                                    <div
                                        className={
                                            "tw:bg-yellow-100 tw:border-l-4 tw:border-yellow-500 tw:text-yellow-700 tw:p-4 tw:m-4"
                                        }
                                    >
                                        {/* eslint-disable-next-line i18next/no-literal-string */}
                                        <IotTypography.Paragraph>
                                            This error detail will be not shown
                                            in production.
                                        </IotTypography.Paragraph>
                                    </div>
                                </IotCol>
                                <IotCol span={24}>{errorDetail}</IotCol>
                            </IotRow>
                        )
                    }
                    status={"500"}
                />
            </IotCol>
        </IotRow>
    );
};
